import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { ratingRulesFindByPage, ratingRulesDelete } from '@/api/overseasSales/ratingRules'
import { PageType } from './hooks/enum'
import { RatingRulesSaveParams } from '@/typings/api/overseasSales'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuRatingRules' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const { t } = useI18n()
// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: RatingRulesSaveParams) => void }>()
const pageType = computed(() => route.path.split('/').pop() || 'ratingRules')
const columns = computed(() => {
  if (pageType.value === 'volumeOfBusinessLevel') {
    return [
      { title: t('operate.g9b9mu'), dataIndex: 'configName' },
      {
        title: pageType.value === 'volumeOfBusinessLevel' ? t('operate.sezilm') : t('operate.v73rkj'),
        dataIndex: 'logic'
      },
      {
        title: t('common.action'),
        dataIndex: 'action',
        fixed: 'right'
      }
    ]
  } else {
    return [
      { title: t('operate.8u7ow3'), dataIndex: 'configName' },
      { title: t('operate.gihkns'), dataIndex: 'logic' },
      {
        title: t('common.action'),
        dataIndex: 'action',
        fixed: 'right'
      }
    ]
  }
})

const tableRef = ref()
const queryForm = reactive({
  name: ''
})

// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  if (pageType.value === 'volumeOfBusinessLevel') {
    ratingRulesFindByPage({ ...params, configType: PageType.LEVEL, appId: 'cos_ofbu' }).then((res) => {
      callBack(res)
    })
  } else {
    ratingRulesFindByPage({ ...params, configType: PageType.RULE, appId: 'cos_ofbu' }).then((res) => {
      callBack(res)
    })
  }
}
const success = () => {
  tableRef.value.fetch()
}

const addEdit = (_row?: RatingRulesSaveParams) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: RatingRulesSaveParams) => {
  Modal.delete({
    name: row.configName,
    onOk() {
      ratingRulesDelete({ id: row.id }).then(() => {
        DcMessage.success(t('operate.6k2ifb'))
        tableRef.value.fetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosRatingRules"
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 0 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 
                  pageType.value === 'volumeOfBusinessLevel' ? 'ofbu_volbuslevel_edit_btn' : 'ofbu_ratingrules_edit_btn'
                ]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 
                  pageType.value === 'volumeOfBusinessLevel' ? 'ofbu_volbuslevel_delete_btn' : 'ofbu_ratingrules_delete_btn'
                ]
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, 
              pageType.value === 'volumeOfBusinessLevel' ? 'ofbu_volbuslevel_add_btn' : 'ofbu_ratingrules_add_btn'
            ]
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            pageType: pageType.value,
            onSuccess: success
          }, null, 8, ["pageType"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})